import {
  Input,
  InputWithIconButton,
  InputIconButton,
  VisibilityOnOutlineIcon,
  VisibilityOffOutlineIcon,
} from "@tandemdiabetes/sugarmate-react-components"
import type { ComponentProps } from "react"
import {
  useCallback,
  useState,
} from "react"

export function PasswordInput(props: ComponentProps<typeof Input>) {
  const [
    showPassword,
    setShowPassword,
  ] = useState(false)

  const toggleShowPassword = useCallback(
    () => {
      setShowPassword(!showPassword)
    },
    [
      showPassword,
      setShowPassword,
    ],
  )

  return (
    <InputWithIconButton>
      <Input
        type={showPassword ? "text" : "password"}
        {...props}
      />
      <InputIconButton
        placementPreset="end"
        onClick={toggleShowPassword}
      >
        {showPassword
          ? <VisibilityOffOutlineIcon />
          : <VisibilityOnOutlineIcon />
        }
      </InputIconButton>
    </InputWithIconButton>
  )
}
